
import React, { useState } from "react";
import { Container, Form, Button, Row, Col, Alert } from "react-bootstrap";
import { User, Phone, Mail, MapPin, Building2, Briefcase, MessageSquare, Send, CheckCircle, AlertCircle, Award, TrendingUp, Users } from 'lucide-react';
import axios from "axios";
import { useNavigate } from 'react-router-dom';

function ContactoTwo() {
    const [formData, setFormData] = useState({
        nombre: "",
        telefono: "",
        email: "",
        departamento: "",
        negocio: "",
        empresa: "",
        mensaje: "",
    });

    const [message, setMessage] = useState(null);
    const [loading, setLoading] = useState(false);
    const [focusedField, setFocusedField] = useState(null);
    
    const navigate = useNavigate();

    const {
        nombre,
        telefono,
        email,
        departamento,
        negocio,
        empresa,
        mensaje
    } = formData;

    const onChange = e => setFormData({...formData, [e.target.name]: e.target.value});
    
    const onSubmit = e => {
        e.preventDefault();
        setLoading(true);
        const config = {
            headers: {
                'Content-Type': 'application/json'
            }
        };

        const formDataToSend = new FormData();
        formDataToSend.append('nombre', nombre);
        formDataToSend.append('telefono', telefono);
        formDataToSend.append('email', email);
        formDataToSend.append('departamento', departamento);
        formDataToSend.append('negocio', negocio);
        formDataToSend.append('empresa', empresa);
        formDataToSend.append('mensaje', mensaje);
        
        const fetchData = async() => {
            try {
                //const res = await axios.post(`http://127.0.0.1:8000/api/distribuidor/`, formDataToSend, config);
                const res = await axios.post(`/api/distribuidor/`, formDataToSend, config)
                if(res.status === 200) {
                    setMessage({ type: "success", text: "¡Solicitud enviada con éxito!" });
                    setFormData({
                        nombre: '',
                        telefono: '',
                        email: '',
                        departamento: '',
                        negocio: '',
                        empresa: '',
                        mensaje: '',
                    });
                    setTimeout(() => {
                        navigate('/thanks');
                    }, 2000);
                } else {
                    setMessage({ type: "danger", text: "Error al enviar la solicitud" });
                }
            } catch (error) {
                setMessage({ type: "danger", text: "Error al enviar la solicitud" });
            }
            setLoading(false);
        };
        fetchData();
    };

    const departamentos = [
        "Cochabamba", "Santa Cruz", "La Paz", "Sucre",
        "Oruro", "Potosí", "Tarija", "Pando", "Beni"
    ];

    const tiposNegocio = [
        "Aceros y perfiles",
        "Casa de iluminación",
        "Casa de materiales",
        "Cerrajería",
        "Distribuidor mayorista",
        "Distribuidor de productos agrícolas",
        "Distribuidor de pinturas",
        "Distribuidor de plomería",
        "Eléctrica",
        "Ferretería",
        "Jardinería",
        "Tornillería",
        "Otros"
    ];

    const beneficios = [
        { icon: <Award size={24} />, text: "Precios especiales para distribuidores" },
        { icon: <TrendingUp size={24} />, text: "Soporte técnico y comercial" },
        { icon: <Users size={24} />, text: "Capacitación continua" }
    ];

    return (
        <section className="distribuidor-form-section">
            {/* Fondo decorativo */}
            <div className="distribuidor-form-background">
                <div className="form-bg-shape form-bg-shape-1"></div>
                <div className="form-bg-shape form-bg-shape-2"></div>
                <div className="form-bg-dots"></div>
            </div>

            <Container className="distribuidor-form-container">
                {/* Header del formulario */}
                <div className="distribuidor-form-header text-center">
                    <div className="form-badge">
                        <Briefcase size={20} />
                        <span>Únete a Nosotros</span>
                    </div>
                    <h2 className="form-main-title">
                        Solicitud de <span className="title-highlight-dist">Distribuidor</span>
                    </h2>
                    <p className="form-main-subtitle">
                        Completa el formulario y nos pondremos en contacto contigo para iniciar el proceso
                    </p>
                    <div className="title-divider-dist"></div>
                </div>

                <Row className="g-5">
                    {/* Columna del Formulario */}
                    <Col lg={8}>
                        <div className="form-card-dist">
                            {message && (
                                <Alert 
                                    variant={message.type} 
                                    className={`custom-alert-dist ${message.type}`}
                                    dismissible
                                    onClose={() => setMessage(null)}
                                >
                                    <div className="alert-content-dist">
                                        {message.type === "success" ? (
                                            <CheckCircle size={24} />
                                        ) : (
                                            <AlertCircle size={24} />
                                        )}
                                        <span>{message.text}</span>
                                    </div>
                                </Alert>
                            )}

                            <Form onSubmit={e => onSubmit(e)} className="distribuidor-form">
                                {/* Sección: Datos de Contacto */}
                                <div className="form-section">
                                    <h3 className="section-title">
                                        <User size={20} />
                                        Datos de Contacto
                                    </h3>

                                    <Row>
                                        {/* Nombre */}
                                        <Col md={6}>
                                            <Form.Group className="form-group-dist">
                                                <div className="input-wrapper-dist">
                                                    <div className={`input-icon-dist ${focusedField === 'nombre' ? 'focused' : ''}`}>
                                                        <User size={20} />
                                                    </div>
                                                    <Form.Control
                                                        type="text"
                                                        name="nombre"
                                                        value={formData.nombre}
                                                        onChange={e => onChange(e)}
                                                        onFocus={() => setFocusedField('nombre')}
                                                        onBlur={() => setFocusedField(null)}
                                                        required
                                                        placeholder="Nombre completo"
                                                        className="form-input-dist"
                                                    />
                                                </div>
                                            </Form.Group>
                                        </Col>

                                        {/* Teléfono */}
                                        <Col md={6}>
                                            <Form.Group className="form-group-dist">
                                                <div className="input-wrapper-dist">
                                                    <div className={`input-icon-dist ${focusedField === 'telefono' ? 'focused' : ''}`}>
                                                        <Phone size={20} />
                                                    </div>
                                                    <Form.Control
                                                        type="tel"
                                                        name="telefono"
                                                        value={formData.telefono}
                                                        onChange={e => onChange(e)}
                                                        onFocus={() => setFocusedField('telefono')}
                                                        onBlur={() => setFocusedField(null)}
                                                        pattern="[0-9]{7,15}"
                                                        required
                                                        placeholder="Teléfono"
                                                        className="form-input-dist"
                                                    />
                                                </div>
                                            </Form.Group>
                                        </Col>

                                        {/* Departamento */}
                                        <Col md={6}>
                                            <Form.Group className="form-group-dist">
                                                <div className="input-wrapper-dist">
                                                    <div className={`input-icon-dist ${focusedField === 'departamento' ? 'focused' : ''}`}>
                                                        <MapPin size={20} />
                                                    </div>
                                                    <Form.Select
                                                        name="departamento"
                                                        value={formData.departamento}
                                                        onChange={e => onChange(e)}
                                                        onFocus={() => setFocusedField('departamento')}
                                                        onBlur={() => setFocusedField(null)}
                                                        required
                                                        className="form-input-dist form-select-dist"
                                                    >
                                                        <option value="">Seleccionar departamento</option>
                                                        {departamentos.map((dept, index) => (
                                                            <option key={index} value={dept}>{dept}</option>
                                                        ))}
                                                    </Form.Select>
                                                </div>
                                            </Form.Group>
                                        </Col>

                                        {/* Email */}
                                        <Col md={6}>
                                            <Form.Group className="form-group-dist">
                                                <div className="input-wrapper-dist">
                                                    <div className={`input-icon-dist ${focusedField === 'email' ? 'focused' : ''}`}>
                                                        <Mail size={20} />
                                                    </div>
                                                    <Form.Control
                                                        type="email"
                                                        name="email"
                                                        value={formData.email}
                                                        onChange={e => onChange(e)}
                                                        onFocus={() => setFocusedField('email')}
                                                        onBlur={() => setFocusedField(null)}
                                                        required
                                                        placeholder="Correo electrónico"
                                                        className="form-input-dist"
                                                    />
                                                </div>
                                            </Form.Group>
                                        </Col>
                                    </Row>
                                </div>

                                {/* Sección: Información del Negocio */}
                                <div className="form-section">
                                    <h3 className="section-title">
                                        <Briefcase size={20} />
                                        Información de tu Negocio
                                    </h3>

                                    <Row>
                                        {/* Tipo de Negocio */}
                                        <Col md={6}>
                                            <Form.Group className="form-group-dist">
                                                <div className="input-wrapper-dist">
                                                    <div className={`input-icon-dist ${focusedField === 'negocio' ? 'focused' : ''}`}>
                                                        <Briefcase size={20} />
                                                    </div>
                                                    <Form.Select
                                                        name="negocio"
                                                        value={formData.negocio}
                                                        onChange={e => onChange(e)}
                                                        onFocus={() => setFocusedField('negocio')}
                                                        onBlur={() => setFocusedField(null)}
                                                        required
                                                        className="form-input-dist form-select-dist"
                                                    >
                                                        <option value="">Tipo de negocio</option>
                                                        {tiposNegocio.map((tipo, index) => (
                                                            <option key={index} value={tipo}>{tipo}</option>
                                                        ))}
                                                    </Form.Select>
                                                </div>
                                            </Form.Group>
                                        </Col>

                                        {/* Nombre de Empresa */}
                                        <Col md={6}>
                                            <Form.Group className="form-group-dist">
                                                <div className="input-wrapper-dist">
                                                    <div className={`input-icon-dist ${focusedField === 'empresa' ? 'focused' : ''}`}>
                                                        <Building2 size={20} />
                                                    </div>
                                                    <Form.Control
                                                        type="text"
                                                        name="empresa"
                                                        value={formData.empresa}
                                                        onChange={e => onChange(e)}
                                                        onFocus={() => setFocusedField('empresa')}
                                                        onBlur={() => setFocusedField(null)}
                                                        required
                                                        placeholder="Nombre de tu empresa"
                                                        className="form-input-dist"
                                                    />
                                                </div>
                                            </Form.Group>
                                        </Col>
                                    </Row>
                                </div>

                                {/* Mensaje */}
                                <div className="form-section">
                                    <h3 className="section-title">
                                        <MessageSquare size={20} />
                                        Mensaje Adicional
                                    </h3>

                                    <Form.Group className="form-group-dist">
                                        <div className="input-wrapper-dist">
                                            <div className={`input-icon-dist textarea-icon-dist ${focusedField === 'mensaje' ? 'focused' : ''}`}>
                                                <MessageSquare size={20} />
                                            </div>
                                            <Form.Control
                                                as="textarea"
                                                rows={5}
                                                name="mensaje"
                                                value={formData.mensaje}
                                                onChange={e => onChange(e)}
                                                onFocus={() => setFocusedField('mensaje')}
                                                onBlur={() => setFocusedField(null)}
                                                required
                                                placeholder="Cuéntanos sobre tu negocio y por qué quieres ser distribuidor..."
                                                className="form-input-dist form-textarea-dist"
                                            />
                                        </div>
                                    </Form.Group>
                                </div>

                                {/* Botón Submit */}
                                <div className="form-submit-wrapper-dist">
                                    <Button
                                        type="submit"
                                        disabled={loading}
                                        className="btn-distribuidor-submit"
                                    >
                                        {loading ? (
                                            <>
                                                <span className="spinner-dist"></span>
                                                <span>Enviando solicitud...</span>
                                            </>
                                        ) : (
                                            <>
                                                <span>Enviar Solicitud</span>
                                                <Send size={20} />
                                            </>
                                        )}
                                    </Button>
                                </div>
                            </Form>
                        </div>
                    </Col>

                    {/* Columna de Beneficios */}
                    <Col lg={4}>
                        <div className="beneficios-sidebar">
                            <div className="beneficios-header">
                                <h3 className="beneficios-title">Beneficios de ser Distribuidor</h3>
                            </div>

                            <div className="beneficios-list">
                                {beneficios.map((beneficio, index) => (
                                    <div 
                                        key={index} 
                                        className="beneficio-card"
                                        style={{ animationDelay: `${index * 0.1}s` }}
                                    >
                                        <div className="beneficio-icon-wrapper">
                                            {beneficio.icon}
                                        </div>
                                        <span className="beneficio-text">{beneficio.text}</span>
                                    </div>
                                ))}
                            </div>

                            <div className="requisitos-card">
                                <h4 className="requisitos-title">Requisitos Básicos</h4>
                                <ul className="requisitos-list">
                                    <li><CheckCircle size={16} /> Establecimiento comercial</li>
                                    <li><CheckCircle size={16} /> Experiencia en el rubro</li>
                                    <li><CheckCircle size={16} /> Referencias comerciales</li>
                                    <li><CheckCircle size={16} /> Capacidad de compra</li>
                                </ul>
                            </div>

                            <div className="info-card-dist">
                                <h4 className="info-card-title">¿Necesitas más información?</h4>
                                <p className="info-card-text">
                                    Nuestro equipo está listo para ayudarte
                                </p>
                                <a href="https://wa.me/59160379365?text=Hola%2C%20me%20interesa%20información%20sobre%20herramientas%20Truper" target="blank" className="btn-info-dist">
                                    Contactar
                                </a>
                            </div>
                        </div>
                    </Col>
                </Row>
            </Container>
        </section>
    );
}

export default ContactoTwo;